<template>
    <section class="component-page-number mb-3">
        <div class="col-12" v-if="lengthList">
            <div class="text-center">
                <button :class="{nextDeactive:nextDeactive}" :disabled="nextDeactive" class="bttn-material-circle flaticon-right-arrow bttn-md bttn-primary" v-ripple  :title="'صفحه بعد'" @click="handelNext"></button>
                <button class="px-3 bttn-minimal bttn-md bttn-success" v-ripple  :title="'صفحه '+ activePage">{{activePage}}</button>
                <button :class="{prevDeactive:prevDeactive}" :disabled="prevDeactive" class="bttn-material-circle flaticon-left-arrow bttn-md bttn-primary" v-ripple  :title="'صفحه قبل'" @click="handelPerv"></button>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: 'component-page-number',
  props: ['lengthList'],
  data () {
    return {
      activePage: 1,
      nextDeactive: false,
      prevDeactive: true
    }
  },
  watch: {
    activePage (newValue, oldValue) {
      if (newValue > 1) {
        this.prevDeactive = false
      } else {
        this.prevDeactive = true
      }
    },
    lengthList (newValue, oldValue) {
      if (newValue == 0) {
        this.handelPerv()
        this.nextDeactive = true
        this.$root.showInfoMsg({
          message: 'اطلاعاتی یافت نشد'
        })
      }
    }
  },
  methods: {
    handelNext () {
      this.activePage += 1
      this.$emit('callBack', this.activePage)
      window.scrollTo(0, 0)
    },
    handelPerv () {
      this.activePage -= 1
      this.$emit('callBack', this.activePage)
      if (this.lengthList > 0) {
        this.nextDeactive = false
      }
      window.scrollTo(0, 0)
    },
    lastActive () {

    }
  }
}
</script>

<style lang="less">
.component-page-number {
  .prevDeactive,
  .nextDeactive {
      cursor: not-allowed;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pageNumber.vue